module.exports = __webpack_public_path__ + "img/22.a296bf3f.png";